import { defineSlotRecipe } from '@chakra-ui/react';
export const tableRecipe = defineSlotRecipe({
    className: 'table',
    slots: ['root', 'header', 'body', 'row', 'columnHeader', 'cell'],
    base: {
        root: {
            w: 'full',
            tableLayout: 'auto',
            borderCollapse: 'separate',
            borderSpacing: 0,
            overflow: 'visible',
            rounded: 'none',
            border: 'none',
            shadow: 'none',
            bg: 'white',
        },
        header: {
            position: 'relative',
        },
        body: {
            position: 'relative',
        },
        row: {
            position: 'relative',
            transition: 'background-color 0.2s ease',
            _hover: {
                bg: 'rowHoverBg',
            },
        },
        columnHeader: {
            px: 4,
            py: 3,
            textAlign: 'left',
            fontFamily: 'heading',
            fontSize: '11.5px',
            fontWeight: 'semibold',
            color: 'navInactive',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
        },
        cell: {
            px: 4,
            py: 3,
            fontSize: 'sm',
            color: 'gray.900',
            verticalAlign: 'middle',
        },
    },
    variants: {
        variant: {
            line: {
                root: {
                    border: 'none',
                    rounded: 'none',
                    shadow: 'none',
                    overflow: 'visible',
                    bg: 'transparent',
                    tableLayout: 'auto',
                    '& th': {
                        bg: 'transparent',
                    },
                },
                columnHeader: {
                    borderBottom: '1px solid',
                    borderBottomColor: 'border.subtle',
                },
                cell: {
                    borderBottom: '1px solid',
                    borderBottomColor: 'border.subtle',
                },
                row: {
                    _last: {
                        '& td': {
                            borderBottom: 'none',
                        },
                    },
                },
            },
            outline: {
                root: {
                    bg: 'white',
                    boxShadow: 'none',
                    '& table': {
                        boxShadow: 'none !important',
                    },
                },
                header: {},
                columnHeader: {
                    bg: 'gray.50',
                    border: 'none',
                },
                row: {
                    _last: {
                        '& td': {
                            borderBottom: 'none',
                        },
                    },
                },
                cell: {
                    borderBottom: '1px solid',
                    borderBottomColor: 'hairline.row',
                },
            },
        },
        size: {
            sm: {
                root: {},
                columnHeader: {
                    px: 3,
                    py: 2,
                    fontSize: '11.5px',
                },
                cell: {
                    px: 3,
                    py: 2,
                    fontSize: 'sm',
                },
            },
            md: {
                root: {},
                columnHeader: {
                    px: 4,
                    py: 3,
                    fontSize: '11.5px',
                },
                cell: {
                    px: 4,
                    py: 3,
                    fontSize: 'sm',
                },
            },
            lg: {
                root: {},
                columnHeader: {
                    px: 5,
                    py: 4,
                    fontSize: 'md',
                },
                cell: {
                    px: 5,
                    py: 4,
                    fontSize: 'md',
                },
            },
        },
        colorPalette: {
            gray: {
                header: {
                    bg: 'softCream',
                },
                row: {
                    _hover: {
                        bg: 'rowHoverBg',
                    },
                },
                columnHeader: {
                    bg: 'background',
                    color: 'navInactive',
                },
            },
            // The companion's tables (`@fluenceur/agent-blocks`): the same table,
            // painted from `agent.*` so it follows the host's colour scheme.
            agent: {
                root: {
                    bg: 'agent.surface',
                },
                header: {
                    bg: 'agent.muted',
                },
                // Chakra's own rows paint `bg`, which is black in a dark scheme.
                row: {
                    bg: 'agent.surface',
                    _hover: {
                        bg: 'agent.hoverBg',
                    },
                },
                columnHeader: {
                    bg: 'agent.muted',
                    color: 'agent.fgMuted',
                    borderBottomColor: 'agent.divider',
                },
                cell: {
                    color: 'agent.fgBody',
                    borderBottomColor: 'agent.divider',
                },
            },
        },
    },
    defaultVariants: {
        variant: 'outline',
        size: 'md',
        colorPalette: 'gray',
    },
});
